<div class="th-menulevel">
  <div class="ir-btn ir-btn--big" [ngClass]="isVisible('general') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'general')">
    <i *ngIf="isVisible('general')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.general' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [ngClass]="isVisible('edit') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'edit')">
    <i *ngIf="isVisible('edit')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.edit' | translate }}</span>
  </div>
  <div *ngIf="!hideModules" class="ir-btn ir-btn--big"
    [ngClass]="isVisible('modules') ? 'th-btn-action' : 'th-btn-menulevel'" (click)="showGroup($event, 'modules')">
    <i *ngIf="isVisible('modules')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.modules' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big" [ngClass]="isVisible('plugins') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'plugins')">
    <i *ngIf="isVisible('plugins')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.plugins' | translate }}</span>
  </div>
  <div class="th-menulevel--area">
    <div class="th-menulevel--areacontent">
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.Information)">
        <span>{{ 'menus.information' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.Properties)">
        <span>{{ 'menus.properties' | translate }}</span>
      </div>
      <!-- <div
        *ngIf="isVisible('general') && isMaintenance"
        class="ir-btn ir-btn--area th-btn-menusublevel ir-inputfile"
        (click)="selectMenu(items.ImportParts)"
      >
        <span>{{ 'menus.import' | translate }} {{ 'menus.parts' | translate }}</span>
      </div> -->
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.AssociateMachines)">
        <span>{{ 'menus.associate-machines' | translate }}</span>
      </div>
      <!--<div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(items.Status)">
          <span>{{ 'common.status' | translate  }}</span>
        </div>-->
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.DownloadTranslation)">
        <span>{{ 'menus.export-data-translations' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.ImportTranslation)">
        <span>{{ 'menus.import-data-translations' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-remove" (click)="selectMenu(items.Delete)">
        <span>{{ 'menus.delete-template' | translate }}</span>
      </div>
      <div *ngIf="isVisible('edit') && !isInOffline"
        class="ir-btn ir-btn--area th-btn-{{ anyModules ? 'remove' : 'disabled' }}"
        (click)="selectMenu(items.DeleteSelectedModules)">
        <span>{{ 'menus.delete-modules' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.ImportModule)">
        <span>{{ 'menus.import' | translate }} {{ 'menus.module' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.CreateModule)">
        <span>{{ 'menus.create' | translate }} {{ 'menus.module' | translate }}</span>
      </div>
      <div *ngIf="isVisible('modules')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.OrderModules)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.modules' | translate }}</span>
      </div>
      <div *ngIf="isVisible('plugins')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.AddPlugin)">
        <span>{{ 'menus.add' | translate }} {{ 'menus.plugin' | translate }}</span>
      </div>
      <div *ngIf="isVisible('plugins')" class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(items.OrderPlugins)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.plugins' | translate }}</span>
      </div>
    </div>
  </div>
</div>